const contractModalRouter = (beforeEnter, name, nested, edit, singleName, requesterType) => {
    let param = {
        beforeEnter: beforeEnter,
        name: name,
        path: '/' + nested + '/' + ((edit) ? 'detalhe/:id' : 'cadastrar'),
        meta: {
            requiresAuth: true,
            isEmployee: edit,
            showModal: true,
            layout: 'default',
            singleName,
            requesterType
        },
        props: true,
        components: {
            contractModal: () => import('@/views/contract/FormContract.vue')
        }
    }
    return param
}

export default contractModalRouter
